import React from "react";

const UserIcon = ({ width, height }: any) => {
  return (
    <>
      <svg width={width} height={height} viewBox="0 0 47 48" fill="none">
        <rect y="0.5" width="47" height="47" rx="23.5" fill="#D0D7DD" />
        <path
          d="M16.1301 16.5788C16.1301 20.2612 19.2932 23.2578 23.1801 23.2578C27.067 23.2578 30.2301 20.2612 30.2301 16.5788C30.2301 12.8965 27.067 9.8999 23.1801 9.8999C19.2932 9.8999 16.1301 12.8965 16.1301 16.5788ZM35.7134 38.0999H37.2801V36.6157C37.2801 30.8881 32.3592 26.2262 26.3134 26.2262H20.0467C13.9994 26.2262 9.08008 30.8881 9.08008 36.6157V38.0999H35.7134Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default UserIcon;
